export default __webpack_public_path__ + "5dae292dde137a3f9d57df8fe7d530ee.mp3";